import React, { useState, useEffect } from "react";
import LeftSection from "./LeftSection";
import APS_URL from "../../../utils/APS_URL";
import {
  GanttPanelWrapper,
  LeftSectionWrapper,
  GanttIFframe,
  ModalOverlay,
} from "./styles";
import LoadingSmall from "../Loading/LoadingSmall";
import { useParams } from "react-router-dom";

// 간트차트 페이지
function AiGantt() {
  const { group_code, project_code } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const toggleOrderModal = () => {
    setOrderModalOpen(!orderModalOpen);
  };
  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };
  useEffect(() => {
    const onMessageListener = ({ data }) => {
      if (data === "open_order_list") {
        toggleOrderModal();
      }
      if (data === "screen_toggle") {
        // 전체화면 toggle
        toggleFullScreen();
      }
    };
    window.addEventListener("message", onMessageListener);
    return () => window.removeEventListener("message", onMessageListener);
  }, [orderModalOpen, isFullScreen]);
  const handleIframeLoad = () => {
    setIsLoading(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <>
      <GanttPanelWrapper $isFullScreen={isFullScreen}>
        {isLoading && <LoadingSmall />}
        <GanttIFframe
          title="gantt"
          width="100%"
          height="100%"
          src={`${APS_URL}/ai_gantt_frame?group_code=${group_code}&project_code=${project_code}`}
          // src={`http://localhost:7100/backend/aps/ai_gantt_frame?group_code=${group_code}&project_code=${project_code}`}
          allow="cross-origin-isolated; accelerometer; gyroscope;"
          onLoad={handleIframeLoad}
          $isFullScreen={isFullScreen}
        />
      </GanttPanelWrapper>
      {orderModalOpen && (
        <>
          <ModalOverlay onClick={toggleOrderModal} />
          <LeftSectionWrapper>
            <LeftSection onClose={toggleOrderModal} />
          </LeftSectionWrapper>
        </>
      )}
    </>
  );
}

export default AiGantt;
